module.exports = __webpack_public_path__ + "static/img/p-img2.a117463.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/forum/p-img2.png
// module id = LHZf
// module chunks = 202